import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';

import PaymentDataModal from 'components/orders/PaymentDataModal/container';

export default styled(PaymentDataModal)`
  padding: ${gridSizes('S')};

  img {
    width: 100%;
  }

  .info-block {
    padding: 0px 12px;
    .title {
      margin: ${gridSizes('S')} 0px;
      font-size: ${gridSizes('L')};
      color: var(--grey900);
      font-weight: ${weights('bold')};
    }

    .label {
      font-family: Roboto;
      font-size: ${gridSizes('M')};
      color: var(--grey700);
      margin: ${gridSizes('S')} auto;
    }
    button {
      margin-top: ${gridSizes('M')};
      font-family: Roboto;
      font-size: ${gridSizes('M')};
      font-weight: bold;

      line-height: 1.13;
    }
  }

  .secondary {
    button {
      background-color: #e0eaff;
      color: #002575;

      &:hover {
        background-color: #6797fe;
      }
    }
  }
  ${media.lessThan('extraSmall')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    background: #fff;
  `};
`;
